function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.136 19.625L32 12H20L16 0l-4 12H0l9.875 7.594L6 32l10.016-7.68L26.008 32z"
});

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj4KICA8cG9seWdvbiBwb2ludHM9IjIyLjEzNiAxOS42MjUgMzIgMTIgMjAgMTIgMTYgMCAxMiAxMiAwIDEyIDkuODc1IDE5LjU5NCA2IDMyIDE2LjAxNiAyNC4zMiAyNi4wMDggMzIiLz4KPC9zdmc+Cg==";
export { SvgStar as ReactComponent };